import { DEFAULT_CONFIG } from '../../../../muze/src/defaults';

const DEFAULT_WIDTH = 600;
const DEFAULT_HEIGHT = 400;
const DEFAULT_CLASS_NAME = `${DEFAULT_CONFIG.classPrefix}-layout-container-component`;
const NODE_PREFIX = `${DEFAULT_CONFIG.classPrefix}-layout-container`;

export {
  DEFAULT_WIDTH,
  DEFAULT_HEIGHT,
  DEFAULT_CLASS_NAME,
  NODE_PREFIX
};
